import { useEffect, useState } from "react";
import { fetchPointSummary } from "./rewardAPI";

// 상단 바의 포인트를 상점 화면이 바꾸면 곧바로 따라가게 하는 작은 알림 통로.
// 포인트는 이 두 곳만 쓰므로 redux 에 새 조각을 만들지 않는다.
const EVENT_NAME = "reward-balance-changed";

export const announceBalance = (balance) => {
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: balance }));
};

// 상점을 켜지 않은 학원(기프티쇼 키 + 활성화 체크 전)이면 isOpen 이 false 라 상단 바가 포인트·상점을 감춘다.
export const usePointBalance = (isEnabled) => {
  const [balance, setBalance] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!isEnabled) return undefined;
    let isCurrent = true;
    fetchPointSummary()
      .then((data) => {
        if (!isCurrent) return;
        setBalance(data.balance);
        setIsOpen(Boolean(data.is_open));
      })
      .catch(() => {});
    const onChange = (event) => setBalance(event.detail);
    window.addEventListener(EVENT_NAME, onChange);
    return () => {
      isCurrent = false;
      window.removeEventListener(EVENT_NAME, onChange);
    };
  }, [isEnabled]);
  return { balance, isOpen };
};

export const formatPoint = (value) => `${(value ?? 0).toLocaleString("ko-KR")}P`;
